import React from 'react';
import PropTypes from 'prop-types';

/**
 * Web Components mark: angle brackets around a 2×2 grid of component tiles,
 * with one tile highlighted as a component "plugging in".
 * Keep in sync with public/favicon.svg and public/logo.svg.
 */
export default function AppLogo({ size = 40 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      <rect width="64" height="64" rx="14" fill="#447952" />
      <g fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 20 L10 32 L19 44" />
        <path d="M45 20 L54 32 L45 44" />
      </g>
      <rect x="23.5" y="23.5" width="7.5" height="7.5" rx="2" fill="#FFFFFF" />
      <rect x="33" y="23.5" width="7.5" height="7.5" rx="2" fill="#B9E4A0" />
      <rect x="23.5" y="33" width="7.5" height="7.5" rx="2" fill="#FFFFFF" />
      <rect x="33" y="33" width="7.5" height="7.5" rx="2" fill="#FFFFFF" />
    </svg>
  );
}

AppLogo.propTypes = { size: PropTypes.number };
